export {
  default as centroidsMerge
} from '../packages/array-xy-centroids-merge/src';
export { default as closestX } from '../packages/array-xy-closest-x/src';
export { default as maxMerge } from '../packages/array-xy-max-merge/src';
export { default as maxY } from '../packages/array-xy-max-y/src';
export { default as sortX } from '../packages/array-xy-sort-x/src';
export {
  default as weightedMerge
} from '../packages/array-xy-weighted-merge/src';



// WEBPACK FOOTER //
// ./src/index.js